import GeneralUtils from "../utils/GeneralUtils";

export default class TillService {
    constructor(props) {
        this.baseURL = props;
    }

    async getTokens() {
        if (GeneralUtils.isNullOrEmpty(localStorage.getItem("token_url"))) {
            return null;
        }
        const url = 'http://' + localStorage.getItem("token_url") + ':8080';
        const TIMEOUT_MS = 8000;

        const fetchPromise = fetch(url + '/artpos/dispatcher/webmarket/auth/tokens', {
            method: 'get',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
            }
        }).then(response => {
            const result = response.clone();
            return GeneralUtils.responseToJson(result);
        });

        const timeoutPromise = new Promise((_, reject) => {
            setTimeout(() => reject(new Error('Connection timeout')), TIMEOUT_MS);
        });

        return Promise.race([fetchPromise, timeoutPromise]);
    }


}